module.exports = __webpack_public_path__ + "img/icon-arrow-down@3x.29547037.png";